<template>
    <div class="error-container">
        <img src="../assets/images/err_icon.png" alt="">
        <p>抱歉,您暂无权限登录该系统！ 
            <!-- <a class="error-link" @click="clickLogin">重新登录</a> -->
        </p>
    </div>
</template>

<script>
export default {
    name: "error-page",
    data() {
        return {
        }
    },
    methods: {
        /**
         * 重新登录
         */
         clickLogin(){
            ssoClient.logout(process.env.VUE_APP_DOMAIN);
            // ssoClient.login(
            //         process.env.VUE_APP_APPID
            //     );
         }
    },
    mounted() {
       
    }
}
</script>

<style lang="scss" scoped>
.error-container{
    background: #fff;
    width: 100%;
    height: 100%;
    text-align: center;
    font-size: 18px;
    padding-top: 10%;
    .error-link{
        // margin-left: 20px;
    }
}

</style>
